<template>
    <div class="card-form">
        <div class="flex justify-content-between align-items-start mb-5">
            <h3 class="mb-0">{{ $t('lang.main.subs_form') }}</h3>
            <payed-till :payed-till="payedTill" :expired="expired"></payed-till>
        </div>
        <div class="card">
            <div
                v-if="user.isCurrentTariffPayed"
                class="flex flex-column border-round p-3 tariff__block_info"
            >
                <span class="text-sm label">{{ $t('lang.panel.activity') }} {{ formatDate(new Date()) }}</span>
                <span class="text-sm font-medium">
                    {{ $tm('lang.panel.domain_stat') }}:
                    {{ user.usedLimit }}
                    {{ $t('lang.panel.domain_stat_from') }}
                    {{ user.limitNumber }}
                </span>
            </div>
            <div class="flex flex-column border-round p-3 tariff__block_info">
                <span class="text-sm label">{{ $t('lang.main.subs_user_tariff') }}</span>
                <span class="text-base font-bold text-primary">{{ user.currentTariff.label }}</span>
                <div
                    v-if="user.parent !== 0"
                    class="flex justify-content-between align-items-end flex-wrap row-gap-3 column-gap-2"
                >
                    <div class="flex flex-column">
                        <span class="text-sm label mt-4">{{ $t('lang.panel.tariff_owner') }}</span>
                        <span class="text-base font-bold">{{ user.parentEmail }}</span>
                    </div>
                </div>
            </div>
            <subscription-pay v-if="user.subscriptionId > 0" />
            <form v-if="user && !isFreeTariff && !isPromoTariff" :action="action" method="POST">
                <div v-if="!user.parent || user.parent === 0">
                    <h6 class="mb-3">{{ $t('lang.panel.prolong_subs') }}</h6>
                    <SubscriptionSrock v-model:srok="srok" :tariffPercent="tariffPercent" />
                    <input type="hidden" name="act" value="prolong" />
                    <input type="hidden" name="srokprolong" :value="srok" />
                    <input type="hidden" name="tarifprolong" :value="tariff.id" />
                    <div class="comment-container" v-if="showComment">
                        <div style="padding-top: 10px" v-html="$t('lang.promotion.text')"></div>
                    </div>
                    <div class="grid grid-nogutter mt-3">
                        <div class="col flex align-items-center flex-column sm:flex-row gap-5">
                            <span class="text-4xl font-bold">
                                {{ total }}
                                <span :title="$t('lang.main.currency.title')">{{ $t('lang.main.currency.sign') }}</span>
                            </span>
                            <Button type="submit" class="w-full sm:w-auto" :label="getProlongButtonTitle" />
                        </div>
                    </div>
                </div>
            </form>
            <div
                v-if="user.parent !== 0"
                class="mt-4"
            >
                <Button
                    @click="onOpenDetachOwner"
                    :label="$t('lang.panel.detach_owner')"
                    severity="secondary"
                    outlined
                    size="small"
                />
            </div>
        </div>
        <AdaptersDialog
            :header="$t('lang.panel.detach_owner_dialog.title')"
            :button-agree-label="$t('lang.main.btn.confirm')"
            :callback-agree="onDetachOwner"
            ref="dialog-detach"
        >
            <template #content>
                <div class="grid">
                    <div class="col-12">
                        <span v-html="$t('lang.panel.detach_owner_dialog.text')"></span>
                    </div>
                </div>
            </template>
        </AdaptersDialog>
    </div>
</template>

<script>
import SubscriptionPay from "../SubscriptionPay.vue";
import PayedTill from "./PayedTill.vue";
import moment from "moment";
import Calculator from "../../modules/Calculator";
import RadioButton from 'primevue/radiobutton';
import AdaptersMessage from "../adapters/Message.vue";
import Button from "primevue/button";
import SubscriptionSrock from "../subscription/Srock.vue";
import {FREE} from "../../modules/Calculator";
import AdaptersDialog from "keysso/component/adapters/Dialog.vue";

export default {
    name: "Tariff",
    data: () => ({
        srok: 1,
    }),
    props: {
        user: {
            type: Object,
            required: true
        },
        tariff: {
            type: Object,
            required: true
        },
        tariffPercent: {
            type: Array,
            required: true
        },
        payedTill: {
            type: Date,
        },
        expired: {
            type: Boolean,
            default: () => false,
        },
        balanceInDays: {
            type: Number,
            required: false,
            default: 0
        },
        promotion: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        action() {
            return `/${window.locale}/panel`;
        },

        calc() {
            return new Calculator(this.tariff.id, this.srok)
        },
        total() {
            const calc = this.calc;
            if (calc.isPromo()) {
                return (calc.getAmount() - this.balanceInDays).formatMoney(0, ' ', ' ');
            }
            return calc.getAmount().formatMoney(0, ' ', ' ');
        },
        showComment() {
            return this.promotion;
        },
        getProlongButtonTitle() {
            return this.user.lastPaySumm > 0 && !this.calc.isPromo()
                ? this.$t('lang.panel.prolong_btn')
                : this.$t('lang.panel.buy_btn');
        },
        isFreeTariff() {
            return this.tariff.id === FREE
        },
        isPromoTariff() {
            return this.user.currentTariff.number !== this.user.currentTariff.realNumber
        }
    },
    methods: {
        formatDate: date => moment(date).format('DD.MM.YYYY'),
        onOpenDetachOwner() {
            this.$refs['dialog-detach'].onShow();
        },
        onDetachOwner() {
            window.open(
                sprintf('/%s/panel?action=detachOwner', window.locale),
                '_self'
            );
        },
    },
    components: {
        AdaptersDialog,
        SubscriptionSrock,
        PayedTill,
        SubscriptionPay,
        RadioButton,
        AdaptersMessage,
        Button,
    }
}
</script>

<style scoped>
.tariff__block_info {
    background: rgba(110, 177, 22, 0.1);
    margin-bottom: 0.625rem;
}
.tariff__block_info .label {
    margin-bottom: 0.625rem;
}

</style>
